import { createAction, createStandardAction } from 'typesafe-actions';

import { CardDetailsDTO } from '../../types/dto/CardDetailsDTO';
import { CustomerDataDTO } from '../../types/dto/CustomerDataDTO';
import { InvoiceGroupDTO } from '../../types/dto/InvoiceGroupDTO';
import { MaintenanceContractChartResultDTO } from '../../types/dto/MaintenanceContractChartResultDTO';
import { MaintenanceContractUpgradeChartResultDTO } from '../../types/dto/MaintenanceContractUpgradeChartResultDTO';
import { SRPMMChartResultDTO } from '../../types/dto/SRPMMChartResultDTO';
import { VehicleDataDTO } from '../../types/dto/VehicleDataDTO';
import { VehicleHistoryDTO } from '../../types/dto/VehicleHistoryDTO';
import { CustomerErrorInfo } from './Types';

export const customerDataRequest = createAction('@@app/CUSTOMER_DATA_REQUEST');
export const customerDataSuccess = createStandardAction('@@app/CUSTOMER_DATA_SUCCESS')<CustomerDataDTO>();
export const customerDataFailure = createAction('@@app/CUSTOMER_DATA_FAILURE');

export const vehicleDataRequest = createAction('@@app/VEHICLE_DATA_REQUEST');
export const vehicleDataSuccess = createStandardAction('@@app/VEHICLE_DATA_SUCCESS')<VehicleDataDTO>();
export const vehicleDataFailure = createAction('@@app/VEHICLE_DATA_FAILURE');

export const changePasswordRequest = createAction('@@app/CHANGE_PASSWORD_REQUEST');
export const changePasswordSuccess = createAction('@@app/CHANGE_PASSWORD_SUCCESS');
export const changePasswordFailure = createStandardAction('@@app/CHANGE_PASSWORD_FAILURE')<CustomerErrorInfo>();

export const updateCustomerRequest = createAction('@@app/UPDATE_CUSTOMER_REQUEST');
export const updateCustomerSuccess = createAction('@@app/UPDATE_CUSTOMER_SUCCESS');
export const updateCustomerFailure = createStandardAction('@@app/UPDATE_CUSTOMER_FAILURE')<CustomerErrorInfo>();

export const updateCustomerForSubscriptionRequest = createAction('@@app/UPDATE_CUSTOMER_FOR_SUBSCRIPTION_REQUEST');
export const updateCustomerForSubscriptionSuccess = createAction('@@app/UPDATE_CUSTOMER_FOR_SUBSCRIPTION_SUCCESS');
export const updateCustomerForSubscriptionFailure = createStandardAction('@@app/UPDATE_CUSTOMER_FOR_SUBSCRIPTION_FAILURE')<CustomerErrorInfo>();

export const updateNifRequest = createAction('@@app/UPDATE_NIF_REQUEST');
export const updateNifSuccess = createAction('@@app/UPDATE_NIF_SUCCESS');
export const updateNifFailure = createStandardAction('@@app/UPDATE_NIF_FAILURE')<CustomerErrorInfo>();

export const addVehicleRequest = createAction('@@app/ADD_VEHICLE_REQUEST');
export const addVehicleSuccess = createAction('@@app/ADD_VEHICLE_SUCCESS');
export const addVehicleFailure = createStandardAction('@@app/ADD_VEHICLE_FAILURE')<CustomerErrorInfo>();

export const deleteVehicleRequest = createAction('@@app/DELETE_VEHICLE_REQUEST');
export const deleteVehicleSuccess = createAction('@@app/DELETE_VEHICLE_SUCCESS');
export const deleteVehicleFailure = createStandardAction('@@app/DELETE_VEHICLE_FAILURE')<CustomerErrorInfo>();

export const deleteCardRequest = createAction('@@app/DELETE_CARD_REQUEST');
export const deleteCardSuccess = createAction('@@app/DELETE_CARD_SUCCESS');
export const deleteCardFailure = createStandardAction('@@app/DELETE_CARD_FAILURE')<CustomerErrorInfo>();

export const addValueAndCareCardRequest = createAction('@@app/ADD_VALUE_AND_CARE_CARD_REQUEST');
export const addValueAndCareCardSuccess = createAction('@@app/ADD_VALUE_AND_CARE_CARD_SUCCESS');
export const addValueAndCareCardFailure = createStandardAction('@@app/ADD_VALUE_AND_CARE_CARD_FAILURE')<CustomerErrorInfo>();

export const customerCardsRequest = createAction('@@app/CUSTOMER_CARDS_REQUEST');
export const customerCardsSuccess = createStandardAction('@@app/CUSTOMER_CARDS_SUCCESS')<CardDetailsDTO[]>();
export const customerCardsFailure = createAction('@@app/CUSTOMER_CARDS_FAILURE');

export const uploadProfilePictureRequest = createAction('@@app/UPLOAD_PROFILE_PICTURE_REQUEST');
export const uploadProfilePictureSuccess = createAction('@@app/UPLOAD_PROFILE_PICTURE_SUCCESS');
export const uploadProfilePictureFailure = createStandardAction('@@app/UPLOAD_PROFILE_PICTURE_FAILURE')<CustomerErrorInfo>();

export const uploadVehicleDocsRequest = createAction('@@app/UPLOAD_VEHICLE_DOCS_REQUEST');
export const uploadVehicleDocsSuccess = createAction('@@app/UPLOAD_VEHICLE_DOCS_SUCCESS');
export const uploadVehicleDocsFailure = createStandardAction('@@app/UPLOAD_VEHICLE_DOCS_FAILURE')<CustomerErrorInfo>();

// export const deleteAccountRequest = createAction('@@app/DELETE_ACCOUNT_REQUEST');
// export const deleteAccountSuccess = createAction('@@app/DELETE_ACCOUNT_SUCCESS');
// export const deleteAccountFailure = createStandardAction('@@app/DELETE_ACCOUNT_FAILURE')<CustomerErrorInfo>();

export const vehicleInvoicesRequest = createAction('@@app/VEHICLE_INVOICES_REQUEST');
export const vehicleInvoicesSuccess = createStandardAction('@@app/VEHICLE_INVOICES_SUCCESS')<InvoiceGroupDTO[]>();
export const vehicleInvoicesFailure = createAction('@@app/VEHICLE_INVOICES_FAILURE');

export const vehicleMaintenanceContractsRequest = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_REQUEST');
export const vehicleMaintenanceContractsSuccess = createStandardAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_SUCCESS')<MaintenanceContractChartResultDTO>();
export const vehicleMaintenanceContractsFailure = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_FAILURE');

export const vehicleMaintenanceContractUpgradesRequest = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_UPGRADE_REQUEST');
export const vehicleMaintenanceContractUpgradesSuccess = createStandardAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_UPGRADE_SUCCESS')<MaintenanceContractUpgradeChartResultDTO>();
export const vehicleMaintenanceContractUpgradesFailure = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_UPGRADE_FAILURE');

export const vehicleMaintenanceContractPDFRequest = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_PDF_REQUEST');
export const vehicleMaintenanceContractPDFSuccess = createStandardAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_PDF_SUCCESS')<Blob>();
export const vehicleMaintenanceContractPDFFailure = createAction('@@app/VEHICLE_MAINTENANCE_CONTRACTS_PDF_FAILURE');

export const vehicleSRPMMRequest = createAction('@@app/VEHICLE_SRPMM_REQUEST');
export const vehicleSRPMMSuccess = createStandardAction('@@app/VEHICLE_SRPMM_SUCCESS')<SRPMMChartResultDTO>();
export const vehicleSRPMMFailure = createAction('@@app/VEHICLE_SRPMM_FAILURE');

export const vehicleAllVisitsRequest = createAction('@@app/VEHICLE_ALL_VISITS_REQUEST');
export const vehicleAllVisitsSuccess = createStandardAction('@@app/VEHICLE_ALL_VISITS_SUCCESS')<VehicleHistoryDTO>();
export const vehicleAllVisitsFailure = createAction('@@app/VEHICLE_ALL_VISITS_FAILURE');
